// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import PropTypes from "prop-types";
import PositionList from "./PositionText";
import { useCallback } from "react";
import {
  convertFromUTCToGivenTimezone,
  formatAMPM,
} from "../../../../utils/methods/dateAndTimeMethods";
import { CustomDeleteIcon, CustomFeedbackIcon } from "./DeleteIcon";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import FeedbackModal from "./FeedbackModal";
import { useState } from "react";
import { userRoles } from "../../../../staticData/userRoles";

const demoResponse = {
  status: 200,
  message: "Contractors fetched successfully.",
  success: true,
  contractors: [
    {
      contractorId: "665b7ec739b6d676c3314ec4",
      contractorName: "Test44 name nn ",
      email: "testname44@yopmail.com",
      mobile: "2222222222",
      isApproved: true,
      approvedBy: {},
      approvedOn: "2024-06-01T20:05:33.099Z",
      isGustoApproved: true,
      gustoApprovedBy: {
        name: "Shabaz Malik",
        userId: "661fb65f5b7d210ed4cb16e3",
      },
      gustoApprovedOn: "2025-02-04T15:40:12.672Z",
      contractorType: "w2",
      positionNames: [
        {
          positionName: "Sr. Assistant",
          startDate: "2025-01-30",
          timeIn: "2025-01-30T10:00:00.000Z",
          timeOut: "2025-01-30T16:00:00.000Z",
        },
        {
          positionName: "XYZ ABC",
          startDate: "2025-01-30",
          timeIn: "2025-01-30T22:00:00.000Z",
          timeOut: "2025-01-31T07:00:00.000Z",
        },
        {
          positionName: "PT",
          startDate: "2025-01-31",
          timeIn: "2025-01-30T22:00:00.000Z",
          timeOut: "2025-01-31T07:00:00.000Z",
        },
        {
          positionName: "waiter ",
          startDate: "2025-02-04",
          numberOfHours: 1,
        },
      ],
      SowLinkSend: [false, false, false, false],
      SowGenerated: [true, true, true, true],
      SowLinks: [null, null, null, null],
    },
    {
      contractorId: "677e94d0de2f809973d2d027",
      contractorName: "Tewt kl",
      email: "tesnjgt@yopmail.com",
      mobile: "949494949",
      isApproved: false,
      approvedBy: {
        name: null,
        userId: null,
      },
      approvedOn: null,
      isGustoApproved: true,
      gustoApprovedBy: {
        name: "Shabaz Malik",
        userId: "661fb65f5b7d210ed4cb16e3",
      },
      gustoApprovedOn: "2025-01-30T14:29:08.372Z",
      contractorType: "NA",
      positionNames: [
        {
          positionName: "XYZ ABC",
          startDate: "2025-02-04",
          numberOfHours: 1,
        },
      ],
      SowLinkSend: [false],
      SowGenerated: [false],
      SowLinks: [null],
    },
  ],
  coordinators: [
    {
      _id: "66368e0af08ea883647291f6",
      fullName: "coordinatorst",
      email: "coordinatorst@yopmail.com",
      mobile: "9620818026",
    },
    {
      _id: "6644b429a201fdcdc2482eb5",
      fullName: "saniya ",
      email: "saniyatabassum@yopmail.com",
      mobile: "9620818026",
    },
  ],
  clientFeedbackData: null,
  totalPages: null,
  total: 2,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
  width: "50rem",
  maxWidth: "90vw",
  height: "auto",
  maxHeight: "80vh",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 2,
  overflowY: "auto",
  "@media (max-width: 600px)": {
    width: "80vw",
    maxHeight: "80vh",
  },
};

export default function LoginFeedbackModal({
  open,
  handleClose,
  setShowFeedbackLayout,
}) {
  const loading = false;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [feedbackModal, setFeedbackModal] = useState({
    status: false,
    userData: null,
    userRole: null,
  });

  const getTimeString = useCallback((str) => {
    return formatAMPM(
      convertFromUTCToGivenTimezone({
        dateStr: str,
        timezone: "America/Los_Angeles",
      }),
    );
  }, []);

  const sendFeedbackClickHandler = useCallback(
    (row, userType) => {
      setShowFeedbackLayout(false);
      setFeedbackModal({
        status: true,
        userData: [row],
        userRole: userType,
      });
    },
    [setShowFeedbackLayout],
  );

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h4" color="primary" textAlign="center" mb={2}>
            Share Your Feedback To Help Us Improve!
          </Typography>

          {/* NOTE: table like */}
          {/* contractor name , positions worked on, feedback button, dismiss button */}
          {demoResponse?.contractors?.map((con, i) => (
            <Grid container key={i} alignItems="center">
              {/* Contractor Name */}
              <Grid item xs={8} sm={5}>
                <Typography>{con?.contractorName}</Typography>
              </Grid>

              {/* Positions Worked On */}
              {!isSmallScreen ? (
                <Grid item xs={0} sm={5}>
                  <PositionList
                    showAtLeast={con?.positionNames?.length > 1 ? 0 : 1}
                    positions={con?.positionNames}
                    getTimeString={getTimeString}
                  />
                </Grid>
              ) : null}

              {/* Feedback Button */}
              <Grid item xs={2} sm={1}>
                <CustomFeedbackIcon
                  onClick={() => {
                    sendFeedbackClickHandler(con, userRoles.contractor);
                  }}
                />
              </Grid>

              {/* Dismiss Button */}
              <Grid item xs={2} sm={1}>
                <CustomDeleteIcon onClick={() => {}} />
              </Grid>
            </Grid>
          ))}

          {/* NOTE: provide feedback for multiple contractors, don't show me this again */}
          <Box
            className="bottom-btn-box"
            sx={{ width: "100%", marginTop: "2rem" }}
          >
            <Button
              className="btn-black"
              sx={{ height: "2.5rem !important" }}
              onClick={() => {
                handleClose();
              }}
            >
              <Typography className="btn-text">
                Don&apos;t Show Again
              </Typography>
            </Button>
            <Button
              sx={{ height: "2.5rem !important" }}
              className="btn-pink"
              onClick={() => {}}
            >
              {loading ? (
                <CircularProgress />
              ) : (
                <Typography className="btn-text">
                  Feedback For Multiple Contractors
                </Typography>
              )}
            </Button>
          </Box>

          {/* NOTE: skip for now */}
          <Button variant="text" onClick={handleClose}>
            <Typography
              sx={{
                fontSize: "16px",
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
                textTransform: "lowercase",
              }}
            >
              skip for now
            </Typography>
          </Button>
        </Box>
      </Modal>

      <FeedbackModal
        open={feedbackModal?.status}
        handleClose={() =>
          setFeedbackModal((prev) => {
            setShowFeedbackLayout(true);
            return { ...prev, status: false };
          })
        }
        userData={feedbackModal?.userData}
        userRole={feedbackModal?.userRole}
        getTimeString={getTimeString}
      />
    </>
  );
}

LoginFeedbackModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setShowFeedbackLayout: PropTypes.func,
};